import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .consent-form {
    padding-top: 24px;
  }

  .consent-heading {
    font-size: ${fsDesignToken('fsFontHeadingNormal')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    line-height: ${fsDesignToken('fsFontLineHeightNormal')};
    margin-bottom: 8px;
  }

  .consent-terms {
    padding-left: 24px;

    .consent-term {
      font-size: ${fsDesignToken('fsFontSizeSmall1')};
      font-weight: ${fsDesignToken('fsFontWeightRegular')};
      line-height: ${fsDesignToken('fsFontLineHeightNormal')};
      margin-bottom: 16px;
    }
  }

  .consent-submit {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 32px;

    &.modal {
      margin: 24px 0;
      padding: 0 24px;
    }
  }

  .ufo-consent-text {
    font-size: 14px;
    font-weight: ${fsDesignToken('fsFontWeightRegular')};
    line-height: 21px;
  }

  .ufo-consent-heading {
    font-size: 20px;
    font-weight: ${fsDesignToken('fsFontWeightRegular')};
    line-height: 30px;
    margin-bottom: 16px;
  }

  .ufo-submit-button {
    width: 100%;
  }

  .center-button {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
  }

  .center-img {
    display: block;
    margin: 24px auto 48px;
  }
`;
